import { render, staticRenderFns } from "./Retake.vue?vue&type=template&id=0ffbd216&scoped=true"
import script from "./Retake.vue?vue&type=script&lang=js"
export * from "./Retake.vue?vue&type=script&lang=js"
import style0 from "./Retake.vue?vue&type=style&index=0&id=0ffbd216&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbd216",
  null
  
)

export default component.exports